function toggleVariantPreOrder(id) {
  let variants = $("#variant-data-json").val();
  variants = JSON.parse(variants).variants;

  const variant = variants.find((item) => item.vid == +id);
  var shouldBePreOrder = variant.isPreOrder || !!variant.pre_order;

  if (shouldBePreOrder && !$("body").hasClass("atc--pre-order")) {
    $("body").addClass("atc--pre-order");
  } else if (!shouldBePreOrder && $("body").hasClass("atc--pre-order")) {
    $("body").removeClass("atc--pre-order");
  }
}

// Watch for DOM mutations on the form (catches programmatic changes from <sa-product-form>)
const formObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "value") {
      const $target = $(mutation.target);
      if ($target.hasClass("mobile-selectedVariant")) {
        const variantId = $target.val();
        const isDisabled = $target.hasClass("is-disabled");
        const btnNotify = $(".btn-notify");

        if (isDisabled) {
          $("#AddToCart").hide();
          $("#AddToCartMobile").hide();
          btnNotify.show();
          btnNotify.css("display", "block !important");
        } else {
          $("#AddToCart").show();
          $("#AddToCartMobile").show();
          btnNotify.hide();
          btnNotify.css("display", "none !important");
        }
      }
    }
  });
});

// Start observing once DOM is ready
setTimeout(() => {
  const mobileInput = document.querySelector(".mobile-selectedVariant");
  if (mobileInput) {
    formObserver.observe(mobileInput, {
      attributes: true,
      attributeFilter: ["value", "class"],
    });
  }
}, 500);

$(document)
  .on(`click`, `[showmoredescription]`, function (e) {
    try {
      e.stopImmediatePropagation();

      $(this).closest(`p`).find(`.showLess`).removeClass(`active`);
      $(this).closest(`p`).find(`.showMore`).addClass(`active`);
      $(this).hide();
      $(this)
        .closest(`p`)
        .find(`[showLessDescription]`)
        .css("display", "inline-block");
    } catch (err) {
      console.log(`ERROR [showmoredescription]`, err.message);
    }
  })
  .on(`click`, `[showLessDescription]`, function (e) {
    try {
      e.stopImmediatePropagation();

      $(this).closest(`p`).find(`.showMore`).removeClass(`active`);
      $(this).closest(`p`).find(`.showLess`).addClass(`active`);
      $(this).hide();
      $(this)
        .closest(`p`)
        .find(`[showmoredescription]`)
        .css("display", "inline-block");
    } catch (err) {
      console.log(`ERROR [showLessDescription]`, err.message);
    }
  })

  .on(`click`, `.product-variants__variant`, async function (e) {
    try {
      e.stopImmediatePropagation();
      const handle = $(this).attr(`handle`);

      if (typeof handle !== "undefined" && handle) {
        const getResponse = await getRequest(
          `/products/${handle}?view=data-json`
        );

        applyHTML(getResponse);

        // console.log ( 'getResponse', getResponse );
      }
    } catch (err) {
      console.log(`ERROR .product-variants__variant`, err.message);
    }
  })

  .on(
    `click`,
    `.product-main__info .product-sizes .product-sizes__option`,
    function (e) {
      try {
        e.stopImmediatePropagation();
        //console.log(this);

        let getObject = $(this).closest(`form`).find(`textarea`).val();

        if (typeof getObject !== "undefined" && getObject) {
          getObject = JSON.parse(getObject);
          // console.log( getObject.totalOptions );

          let selectedVariant;

          if (getObject.totalOptions == 1) {
            const getFirstSelectVal = $(this).find(`span`).text().trim();

            selectedVariant = findObjectByKey(
              getObject.variants,
              "vTitle",
              getFirstSelectVal
            );
            console.log(selectedVariant);
          }
          const p = Promise.resolve(selectedVariant);

          p.then((value) => {
            console.log(value.vid); // 👉️ "hello"
            if (typeof value !== "undefined" && value) {
              $(`.selectedVariant`).val(value.vid);
              history.pushState("", "", `?variant=${value.vid}`);

              if (value.vAvail == true || value.isPreOrder == true) {
                $("#AddToCart").show();
                if (value.isPreOrder == true) {
                  $("#AddToCart").text("Pre-Order");
                } else {
                  $("#AddToCart").text("Add to Cart");
                }
                $("#AddToCartMobile").show();
                $(".btn-notify").hide();
              } else {
                $("#AddToCart").hide();
                $("#AddToCartMobile").hide();
                $(".btn-notify").show();
              }

              $("[data-variant-show].active").removeClass("active");
              $(`[data-variant-show="${value.vid}"]`).addClass("active");
              // $('body').toggleClass('atc--pre-order', !!value.pre_order);

              toggleVariantPreOrder(value.vid);
            }

            // triggers klaviyo's back-in-stock
            setTimeout(function () {
              $(".klaviyo__change-trigger").click();
            }, 1);
          }).catch((err) => {
            console.log(err);
          });
          if (typeof selectedVariant !== "undefined" && selectedVariant) {
            $(
              `.product-main__info .product-main__title .product-main__price, .product-main__info .product-main__options .add-2-cart span[price]`
            ).text(`${selectedVariant.vPriceSymbol}${selectedVariant.vPrice}`);

            console.log("selectedVariant", selectedVariant.vid);
            var variantTitle = selectedVariant.vTitle;
            var variantInput = $(document).find('#variant_name');
            var selectedSize = $(document).find('.enquiry__selected-variant .selected--variant');
            if (variantTitle && variantInput && selectedSize) {
              variantInput.val(`Size ${variantTitle}`);
              selectedSize.html(`SIZE: ${variantTitle}`);
            }

            $(this)
              .closest(`.product-main__info`)
              .find(`.product-sizes .product-sizes__option`)
              .removeClass(`selected`);

            $(this).addClass(`selected`);

            $(`.selectedVariant`).val(selectedVariant.vid);

            const link = `/cart/add?id=${selectedVariant.vid}&quantity=1`;

            history.pushState("", "", `?variant=${selectedVariant.vid}`);
            if (
              selectedVariant.vAvail == true ||
              selectedVariant.isPreOrder == true
            ) {
              // $('#AddToCart').show();
              // $('.btn-notify').hide();
              if (selectedVariant.isPreOrder == true) {
                $("#AddToCart").text("Pre-Order");
              } else {
                $("#AddToCart").text("Add to Cart");
              }
            } else {
              $("#AddToCart").hide();
              $("#AddToCartMobile").hide();
              $(".btn-notify").show();
            }

            $("[data-variant-show].active").removeClass("active");
            $(`[data-variant-show="${selectedVariant.vid}"]`).addClass(
              "active"
            );
            // $('body').toggleClass('atc--pre-order', !!selectedVariant.pre_order);

            toggleVariantPreOrder(selectedVariant.vid);

            // triggers klaviyo's back-in-stock
            setTimeout(function () {
              $(".klaviyo__change-trigger").click();
            }, 1);

            // Dispatch custom event for notify modal
            document.dispatchEvent(
              new CustomEvent("variantChanged", {
                detail: { variantId: selectedVariant.vid },
              })
            );
          }
        }
      } catch (err) {
        console.log(
          `ERROR .product-main__info .product-sizes .product-sizes__option`,
          err.message
        );
      }
    }
  );

$(document).on("change", ".mobile-selectedVariant", function () {
  const variantId = $(this).val();
  console.log("[CHANGE EVENT] mobile-selectedVariant changed to:", variantId);
  history.pushState("", "", `?variant=${variantId}`);

  $("[data-variant-show].active").removeClass("active");
  $(`[data-variant-show="${variantId}"]`).addClass("active");
  toggleVariantPreOrder(variantId);

  const isDisabled = $(this).hasClass("is-disabled");
  const btnNotify = $(".btn-notify");
  console.log(
    "[CHANGE EVENT] isDisabled:",
    isDisabled,
    "btnNotify found:",
    btnNotify.length
  );

  if (isDisabled) {
    console.log("[CHANGE EVENT] Showing notify button");
    $("#AddToCart").hide();
    $("#AddToCartMobile").hide();
    btnNotify.show();
    btnNotify.css("display", "block !important");
  } else {
    console.log("[CHANGE EVENT] Hiding notify button");
    $("#AddToCart").show();
    $("#AddToCartMobile").show();
    btnNotify.hide();
    btnNotify.css("display", "none !important");
  }

  // triggers klaviyo's back-in-stock
  setTimeout(function () {
    $(".klaviyo__change-trigger").click();
  }, 1);

  // Dispatch custom event for notify modal
  document.dispatchEvent(
    new CustomEvent("variantChanged", {
      detail: { variantId: variantId },
    })
  );
});

async function applyHTML(o) {
  try {
    console.log("o", o);

    if (typeof o.title !== "undefined" && o.title) {
      $(`.product-main__title h1`).text(o.title);
    }

    if (typeof o.description_50 !== "undefined" && o.description_50) {
      $(`.product-main__description > p .showLess`).html(
        `${o.description_50}<br><span showmoredescription>show more</span>`
      );
    }

    if (typeof o.description !== "undefined" && o.description) {
      $(`.product-main__description > p .showMore`).html(
        `${o.description}<br><span showLessDescription style="display: none;">show less</span>`
      );
    }

    if (typeof o.selected_variant_id !== "undefined" && o.selected_variant_id) {
      $(`.product-main__info .selectedVariant`).val(o.selected_variant_id);
    }

    if (typeof o.images !== "undefined" && o.images) {
      let collectImagesHTML = ``;
      let collectDetailImages = ``;

      o.images.forEach((el, i) => {
        if (i < 2) {
          collectImagesHTML += `<div class="product-main__image"><img src="${el.image}&width=440" alt="${el.title}" loading="lazy"></div>`;
        }

        if (i < 4) {
          collectDetailImages += `<div class="product-details__image"><img src="${el.image}&width=440" alt="${el.title}" loading="lazy"></div>`;
        }
      });

      if (collectImagesHTML != "") {
        $(`.product-main__images.product-main__images--desktop`).html(
          collectImagesHTML
        );
      }

      if (collectDetailImages != "") {
        $(`.product-details__images`).html(collectDetailImages);
      }
    }

    if (
      typeof o.variantsColor !== "undefined" &&
      o.variantsColor &&
      typeof o.totalOptions !== "undefined" &&
      o.totalOptions
    ) {
      const makeObj = {
        variants: o.variantsColor,
        totalOptions: o.totalOptions,
      };

      $(`.product-main__info form textarea`).remove();

      $(`.product-main__info form`).append(
        `<textarea style="display: none;">${JSON.stringify(makeObj)}</textarea>`
      );
    }

    if (
      typeof o.variantsColor !== "undefined" &&
      o.variantsColor &&
      typeof o.selected_variant_id !== "undefined" &&
      o.selected_variant_id
    ) {
      const selectedVariant = findObjectByKey(
        o.variantsColor,
        `vid`,
        o.selected_variant_id
      );

      $(
        `.product-main__title .product-main__price, .product-main__options .add-2-cart span[price]`
      ).text(`${selectedVariant.vPriceSymbol}${selectedVariant.vPrice}`);

      //console.log ( 'selectedVariant', selectedVariant );
      console.log("w/ color");

      const getSelectedSize = $(
        `.product-main__info .product-sizes .product-sizes__option.selected span`
      )
        .text()
        .trim();

      let collectSizeHTML = ``;
      o.variantsColor.forEach((el) => {
        collectSizeHTML += `<label class="product-sizes__option ${
          el.vTitle == getSelectedSize ? `selected` : ``
        }"><input name="product-size" type="radio" ${
          el.vTitle == getSelectedSize ? `checked` : ``
        }><span>${el.vTitle}</span></label>`;
      });

      if (collectSizeHTML != "") {
        $(`.product-main__info .product-sizes`).html(collectSizeHTML);

        await delayApply(50);

        const getSelectedSize = $(
          `.product-main__info .product-sizes .product-sizes__option.selected span`
        )
          .text()
          .trim();

        const selectedVariant = findObjectByKey(
          o.variantsColor,
          `vTitle`,
          getSelectedSize
        );

        $(`.product-main__info .selectedVariant`).val(selectedVariant.vid);
      }

      // console.log ( 'getSelectedSize', getSelectedSize );
    }

    if (typeof o.swatches !== "undefined" && o.swatches) {
      $(`.product-main__options .product-variants`).html(o.swatches);
    }

    await delayApply(200);

    if (typeof o.handle !== "undefined" && o.handle) {
      $(
        `.product-main__info .product-variants .product-variants__variant[handle="${o.handle}"] input`
      ).prop("checked", true);

      const getSelectedSize = $(
        `.product-main__info .product-sizes .product-sizes__option.selected span`
      )
        .text()
        .trim();

      const selectedVariant = findObjectByKey(
        o.variantsColor,
        `vTitle`,
        getSelectedSize
      );

      history.pushState(
        "",
        "",
        `/products/${o.handle}?variant=${selectedVariant.vid}`
      );

      $("[data-variant-show].active").removeClass("active");
      $(`[data-variant-show="${selectedVariant.vid}"]`).addClass("active");

      toggleVariantPreOrder(selectedVariant.vid);

      console.log("swatchses");
      console.log(selectedVariant.vid);
    }
  } catch (err) {
    console.log(`ERROR `, err.message);
  }
}
